var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "b-button",
        {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            disabled: _vm.disabled,
            size: "sm",
            title: "Substitution d'article"
          },
          on: {
            click: function($event) {
              return _vm.show()
            }
          }
        },
        [_c("i", { staticClass: "fas fa-exchange-alt" })]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            size: "xl",
            title: "Substitution d'article",
            "ok-title": "Choisir",
            "ok-disabled": !_vm.article,
            "cancel-title": "Annuler",
            "no-close-on-backdrop": ""
          },
          on: {
            show: function($event) {
              return _vm.init()
            },
            ok: function($event) {
              return _vm.substituerArticle()
            }
          },
          model: {
            value: _vm.afficherModale,
            callback: function($$v) {
              _vm.afficherModale = $$v
            },
            expression: "afficherModale"
          }
        },
        [
          _c(
            "template",
            { slot: "default" },
            [
              _c("RechercheArticles", {
                attrs: { ajoutActif: true, fournisseurId: _vm.fournisseurId },
                on: {
                  "change-ingredient": function($event) {
                    return _vm.changeIngredient($event)
                  },
                  "change-state": function($event) {
                    return _vm.changeEtatRecherche($event)
                  }
                }
              }),
              _vm.stateSearch
                ? _c(
                    "h5",
                    { key: _vm.stateSearch, staticClass: "push-top-1rem" },
                    [_vm._v(" " + _vm._s(_vm.stateSearch) + " ")]
                  )
                : _vm._e(),
              _vm.ingredient && _vm.ingredient.parProduit
                ? _c("ArticlesParProduit", {
                    attrs: {
                      articles: _vm.ingredient.parProduit,
                      favoris: _vm.ingredient.favoris
                    },
                    on: {
                      "selection-article": function($event) {
                        return _vm.setArticle($event)
                      },
                      "validation-article": function($event) {
                        return _vm.substituerArticle()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }